import styled from "styled-components";

export const MainCenter = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  @media (max-width: 520px) {
    justify-content: center;
    align-items: center;
  } ;
`;
export const Woman = styled.img`
  height: 80vh;
  align-self: flex-end;
  @media (max-width: 520px) {
    justify-content: center;
    align-self: center;
    align-items: center;
    height: 50vh;
  } ;
`;

export const SecondContainer = styled.div`
  display: flex;
  @media (max-width: 1000px) {
    flex-direction: column;
  } ;
`;

export const ThirdContainer = styled.div`
  position: relative;
`;

export const ContainerHeadings = styled.div`
  display: flex;
  align-self: center;
  flex-direction: column;
  margin-left: 2rem;
`;
export const Bar = styled.div`
  align-self: center;
  border-left: 2px solid #e4e4e4;

  margin-left: 3rem;
  @media (max-width: 520px) {
    border-left: none;
    width: 90%;
    border-bottom: 2px solid #222222;
    margin-left: 0;
  } ;
`;

export const MainTitle = styled.p`
  font-family: Roboto;
  font-size: 50px;
  font-weight: bold;
  margin-bottom: 0;
  @media (max-width: 520px) {
    font-size: 32px;
  }
`;
export const SecondTitle = styled.p`
  font-family: Raleway;
  font-size: 20px;
`;
export const ThirdTitle = styled.p`
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
  @media (max-width: 520px) {
    font-size: 16px;
  }
`;
export const Btn = styled.svg`
  position: absolute;
  top: 140px;
  cursor: pointer;
`;
export const Arrow = styled.svg`
  position: absolute;
  top: 150px;
  left: 10px;
  cursor: pointer;
`;

export const BackBtn = styled.button`
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.37rem 1.5rem;
  font-size: 0.9rem;
  border-radius: 0.35rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  background-color: #fc5a08;
  border-color: #fc5a08;
  &:hover {
    background-color: white;
    color: #fc5a08;
  }
  @media (max-width: 520px) {
    width: 92%;
  }
`;

interface TypeColor {
  color?: string;
}

export const GoToStart = styled.p<TypeColor>`
  margin-left: 50px;
  cursor: pointer;
  color: ${(props) => props.color};
`;
